'use strict';

var _svg4everybody = require('svg4everybody/dist/svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.initialise = function () {
  (0, _svg4everybody2.default)();
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-svg4everybody.js